import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { validateActiveRequestService, withdrawalRegisterRequestService, getFullInformationCreditService } from "./services/home.service";
import { getDataUserByIdService } from "../Profile/services/profile.service";
import SidebarComponent from "../../components/Sidebar/SidebarComponent";
import StaticsData from "./components/StaticsData";
import { useNavigate } from "react-router-dom";
import CreditsAccordion from "./components/CreditsAccordion";


const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

  .hr-root *, .hr-root *::before, .hr-root *::after {
    box-sizing: border-box;
  }

  .hr-root {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #f4f6f9;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    color: #1a1d23;
  }

  .hr-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    height: 64px;
    background: #ffffff;
    border-bottom: 1px solid #e8eaed;
    position: sticky;
    top: 0;
    z-index: 100;
    flex-shrink: 0;
  }
  .hr-topbar-brand {
    font-size: 1.1rem;
    font-weight: 800;
    color: #1a1d23;
    letter-spacing: -0.5px;
  }
  .hr-topbar-brand span { color: #00A86B; }

  .hr-topbar-right {
    display: flex;
    align-items: center;
    gap: 18px;
  }

  .hr-icon-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid #e8eaed;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #6b7280;
    transition: border-color 0.15s, color 0.15s;
    position: relative;
    padding: 0;
    outline: none;
  }
  .hr-icon-btn:hover { border-color: #00A86B; color: #00A86B; }

  .hr-notif-dot {
    position: absolute;
    top: 3px;
    right: 3px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #e53e3e;
    border: 2px solid #ffffff;
    display: block;
  }

  .hr-avatar-wrap { position: relative; }

  .hr-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #00A86B;
    color: #fff;
    font-weight: 700;
    font-size: 0.82rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    user-select: none;
    letter-spacing: 0.5px;
  }

  .hr-avatar-menu {
    position: absolute;
    top: 44px;
    right: 0;
    background: #ffffff;
    border: 1px solid #e8eaed;
    border-radius: 12px;
    padding: 6px;
    min-width: 180px;
    z-index: 300;
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  }
  .hr-avatar-menu-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 12px;
    border-radius: 8px;
    font-size: 0.83rem;
    color: #1a1d23;
    cursor: pointer;
    transition: background 0.1s;
    white-space: nowrap;
  }
  .hr-avatar-menu-item:hover { background: #f4f6f9; }
  .hr-avatar-menu-item i { color: #6b7280; font-size: 0.9rem; }
  .hr-avatar-menu-divider { height: 1px; background: #e8eaed; margin: 4px 0; }

  .hr-content { display: flex; flex: 1; min-height: 0; }

  .hr-main {
    flex: 1;
    overflow-y: auto;
    padding: 28px 36px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-width: 0;
  }

  .hr-page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
  }
  .hr-page-header h1 {
    margin: 0;
    font-size: 1.55rem;
    font-weight: 800;
    color: #1a1d23;
    letter-spacing: -0.5px;
    line-height: 1.2;
  }
  .hr-page-header h1 span { color: #00A86B; }
  .hr-page-header .hr-date {
    margin: 4px 0 0;
    font-size: 0.78rem;
    color: #9ca3af;
    text-transform: capitalize;
  }

  .hr-loading-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #f0fdf8;
    border: 1px solid #bbf7d0;
    border-radius: 20px;
    padding: 5px 14px;
    font-size: 0.72rem;
    font-weight: 600;
    color: #059669;
  }
  .hr-loading-pill .hr-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #00A86B;
    animation: hrPulse 1.6s ease-in-out infinite;
  }
  @keyframes hrPulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50%       { opacity: 0.4; transform: scale(0.8); }
  }

  .hr-grid { display: grid; grid-template-columns: 1fr; gap: 20px; }

  .hr-balance-card {
    grid-column: 1 / -1;
    background: linear-gradient(140deg, #00A86B 0%, #007a4d 55%, #005535 100%);
    border-radius: 20px;
    padding: 30px 32px;
    color: #fff;
    position: relative;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0,168,107,0.28);
    min-height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .hr-balance-card::before {
    content: '';
    position: absolute;
    top: -70px; right: -50px;
    width: 260px; height: 260px;
    border-radius: 50%;
    background: rgba(255,255,255,0.07);
    pointer-events: none;
  }
  .hr-balance-card::after {
    content: '';
    position: absolute;
    bottom: -90px; right: 100px;
    width: 200px; height: 200px;
    border-radius: 50%;
    background: rgba(255,255,255,0.05);
    pointer-events: none;
  }
  .hr-balance-label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 1.8px;
    text-transform: uppercase;
    opacity: 0.7;
    margin-bottom: 10px;
  }
  .hr-balance-amount {
    font-size: 3rem;
    font-weight: 800;
    letter-spacing: -2px;
    line-height: 1;
    display: flex;
    align-items: baseline;
    gap: 8px;
    position: relative;
    z-index: 1;
  }
  .hr-balance-amount .hr-bal-sym {
    font-size: 1.4rem;
    font-weight: 600;
    opacity: 0.75;
    align-self: flex-start;
    margin-top: 6px;
  }
  .hr-balance-amount .hr-bal-cur {
    font-size: 1rem;
    font-weight: 500;
    opacity: 0.6;
    letter-spacing: 0;
    align-self: flex-end;
    margin-bottom: 4px;
  }
  .hr-balance-meta {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 0.74rem;
    opacity: 0.7;
    margin-top: 14px;
    position: relative;
    z-index: 1;
  }
  .hr-balance-meta .dot {
    width: 7px; height: 7px;
    border-radius: 50%;
    background: #7dffd4;
    animation: hrPulse 2s infinite;
  }

  .hr-withdraw-card {
    grid-column: 1 / -1;
    background: #fff;
    border-radius: 18px;
    border: 1px solid #e8eaed;
    padding: 26px 30px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
  .hr-withdraw-card-empty {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    flex-wrap: wrap;
  }
  .hr-withdraw-icon-wrap {
    width: 52px; height: 52px;
    border-radius: 14px;
    background: #e6faf2;
    color: #00A86B;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    flex-shrink: 0;
  }
  .hr-withdraw-body { flex: 1; min-width: 200px; }
  .hr-withdraw-body h3 { margin: 0 0 3px; font-size: 1rem; font-weight: 700; color: #1a1d23; }
  .hr-withdraw-body .hr-sub { font-size: 0.75rem; color: #9ca3af; margin-bottom: 12px; }
  .hr-withdraw-body p { font-size: 0.85rem; color: #4b5563; line-height: 1.7; margin: 0; }
  .hr-withdraw-body p .hl  { color: #00A86B; font-weight: 600; }
  .hr-withdraw-body p .hl2 { color: #1a1d23; font-weight: 700; }

  .hr-withdraw-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .hr-withdraw-title-row h3 { margin: 0; font-size: 1rem; font-weight: 700; color: #1a1d23; }

  .hr-withdraw-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .hr-withdraw-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    background: #f8fafc;
    border: 1px solid #eef1f4;
    border-radius: 12px;
    padding: 14px 16px;
  }
  .hr-withdraw-item-info { display: flex; flex-direction: column; gap: 3px; }
  .hr-withdraw-item-number { font-weight: 700; font-size: 0.85rem; color: #1a1d23; }
  .hr-withdraw-item-amount { font-size: 0.78rem; color: #6b7280; }
  .hr-withdraw-item-amount b { color: #00A86B; }

  .hr-btn-withdraw.p-button {
    background: #00A86B !important;
    border: none !important;
    border-radius: 12px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-weight: 600 !important;
    font-size: 0.8rem !important;
    padding: 10px 20px !important;
    box-shadow: 0 4px 16px rgba(0,168,107,0.32) !important;
    transition: box-shadow 0.2s, transform 0.15s !important;
    white-space: nowrap;
  }
  .hr-btn-withdraw.p-button:hover {
    box-shadow: 0 8px 24px rgba(0,168,107,0.45) !important;
    transform: translateY(-2px) !important;
    background: #009960 !important;
  }

  .hr-pending-badge {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: #f0fdf8;
    border: 1px solid #bbf7d0;
    color: #059669;
    border-radius: 14px;
    padding: 14px 22px;
    font-size: 0.85rem;
    font-weight: 600;
  }

  .hr-charts {
    background: #fff;
    border-radius: 18px;
    border: 1px solid #e8eaed;
    padding: 26px 30px;
  }
  .hr-charts-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .hr-charts-header h4 { margin: 0; font-size: 0.95rem; font-weight: 700; color: #1a1d23; }
  .hr-charts-pill {
    background: #f4f6f9;
    border-radius: 20px;
    padding: 4px 14px;
    font-size: 0.72rem;
    font-weight: 600;
    color: #6b7280;
  }

  .hr-skeleton {
    display: inline-block;
    width: 180px; height: 48px;
    border-radius: 8px;
    background: linear-gradient(90deg, rgba(255,255,255,0.15) 25%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0.15) 75%);
    background-size: 200% 100%;
    animation: hrShimmer 1.4s ease-in-out infinite;
  }
  @keyframes hrShimmer {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  .p-dialog.p-confirm-dialog {
    background-color: #ffffff !important;
    border-radius: 16px !important;
    box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1) !important;
    border: 1px solid #e2e8f0 !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
  }
  .p-confirm-dialog .p-dialog-header {
    background-color: #ffffff !important;
    color: #1e293b !important;
    border-bottom: 1px solid #f1f5f9 !important;
    padding: 1.25rem 1.5rem !important;
  }
  .p-confirm-dialog .p-dialog-header .p-dialog-title { font-weight: 700 !important; font-size: 1.1rem !important; }
  .p-confirm-dialog .p-dialog-content {
    background-color: #ffffff !important;
    color: #334155 !important;
    padding: 2rem 1.5rem !important;
  }
  .p-confirm-dialog .p-dialog-content .p-confirm-dialog-icon { color: #eab308 !important; font-size: 1.75rem !important; }
  .p-confirm-dialog .p-dialog-content .p-confirm-dialog-message {
    margin-left: 1rem !important;
    font-size: 0.95rem !important;
    line-height: 1.5 !important;
    color: #475569 !important;
  }
  .p-confirm-dialog .p-dialog-footer {
    background-color: #ffffff !important;
    border-top: 1px solid #f1f5f9 !important;
    padding: 1rem 1.5rem !important;
    display: flex !important;
    justify-content: flex-end !important;
    gap: 0.75rem !important;
  }
  .p-confirm-dialog .p-dialog-footer .p-confirm-dialog-accept {
    background-color: #00A86B !important;
    border: 1px solid #00A86B !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    padding: 0.6rem 1.5rem !important;
  }
  .p-confirm-dialog .p-dialog-footer .p-confirm-dialog-accept:hover {
    background-color: #008f5b !important;
    border-color: #008f5b !important;
  }
  .p-confirm-dialog .p-dialog-footer .p-confirm-dialog-reject {
    background-color: #ffffff !important;
    border: 1px solid #cbd5e1 !important;
    color: #64748b !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    padding: 0.6rem 1.5rem !important;
  }
  .p-confirm-dialog .p-dialog-footer .p-confirm-dialog-reject:hover {
    background-color: #f8fafc !important;
    color: #334155 !important;
    border-color: #94a3b8 !important;
  }
  .p-confirm-dialog .p-dialog-header-close-icon { color: #64748b !important; }

  .hr-page-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

  .hr-btn-request-credit.p-button {
    background: #00A86B !important;
    border: none !important;
    border-radius: 12px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-weight: 600 !important;
    font-size: 0.8rem !important;
    padding: 10px 18px !important;
    box-shadow: 0 4px 16px rgba(0,168,107,0.32) !important;
    transition: box-shadow 0.2s, transform 0.15s !important;
    white-space: nowrap;
  }
  .hr-btn-request-credit.p-button:hover {
    box-shadow: 0 8px 24px rgba(0,168,107,0.45) !important;
    transform: translateY(-2px) !important;
    background: #009960 !important;
  }

  @media (max-width: 768px) {
  
    .hr-main { padding: 20px 18px; }
    .hr-topbar { padding: 0 18px; }
    .hr-balance-amount { font-size: 2.2rem; }
    .hr-withdraw-item { flex-direction: column; align-items: stretch; }
    .hr-btn-withdraw.p-button { width: 100% !important; justify-content: center; }
    .p-sidebar-mask { z-index: 9999 !important; }
    .p-sidebar      { z-index: 10000 !important; }
    .hr-page-header-right {
      width: 100%;
      justify-content: space-between;
    }
  }
`;

function Home(): JSX.Element {
  const activeSession = localStorage.getItem("activeSession");
  const idUser        = localStorage.getItem("idUser");
  const toast         = useRef<Toast>(null);
  const navigate      = useNavigate();

  const [validateRequestPending, setValidateRequestPending] = useState<boolean>(false);
  const [balanceProfileUser,     setBalanceProfileUser]     = useState<number | null>(null);
  const [userName,               setUserName]               = useState<string>("");
  const [isLoading,              setIsLoading]              = useState<boolean>(true);
  const [showAvatarMenu,         setShowAvatarMenu]         = useState<boolean>(false);
  const [creditosPorTipo,        setCreditosPorTipo]        = useState<any[]>([]);
  const [withdrawalRequests,     setWithdrawalRequests]     = useState<any[]>([]);

  const today = new Date().toLocaleDateString("es-CO", {
    weekday: "long", year: "numeric", month: "long", day: "numeric",
  });

  const rawName = userName.trim();
  const initials = rawName
    ? rawName.split(/\s+/).slice(0, 2).map((w) => w[0].toUpperCase()).join("")
    : "U";

  useEffect(() => {
    const handler = () => setShowAvatarMenu(false);
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  // Créditos desembolsados (activos) que aún no tienen una solicitud de retiro registrada.
  // Nota: aunque en creditosPorTipo existe "aprobadosPorDesembolsar", el flujo real de
  // negocio es que la solicitud de retiro se genera sobre créditos ya DESEMBOLSADOS,
  // no sobre los que solo están aprobados y a la espera de desembolso.
  const creditsPendingWithdrawal = creditosPorTipo
    .flatMap((grupo: any) => grupo.desembolsados ?? [])
    .filter((credit: any) => credit.status === "activo")
    .filter(
      (credit: any) =>
        !withdrawalRequests.some((wr: any) => wr.idCredit === credit.idCredito)
    );

  const accept = (idCredit: number) => {
    registerWithdrawalRequest({ idUser: idUser ? +idUser : 0, idCredit });
  };

  const reject = () => {
    toast.current?.show({
      severity: "warn",
      summary: "Cancelado",
      detail: "Solicitud no enviada",
      life: 3000,
    });
  };

  const requestSaves = (idCredit: number) => {
    confirmDialog({
      message: "¿Seguro que desea solicitar el retiro de este crédito?",
      header: "Confirmar solicitud de retiro",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: () => accept(idCredit),
      reject,
      acceptLabel: "SÍ",
      rejectLabel: "NO",
    });
  };

  // ── Services ────────────────────────────────────────────────────────────
  const findDataUser = async (): Promise<void> => {
    if (!idUser) { window.location.href = "/"; return; }
    try {
      const response = await getDataUserByIdService(+idUser);
      const data = response?.data;
      if (data) {
        setBalanceProfileUser(data.balance ?? 0);
        const name =
          data.name ??
          data.fullName ??
          data.firstName ??
          data.username ??
          "";
        setUserName(String(name).trim());
        setCreditosPorTipo(data.creditosPorTipo ?? []);
        setWithdrawalRequests(data.withdrawalRequest ?? []);
      }
    } catch (error) {
      console.error("findDataUser error:", error);
      setBalanceProfileUser(0);
    }
  };

  const getActiveRequest = async (): Promise<void> => {
    if (!idUser) { window.location.href = "/"; return; }
    try {
      const response = await validateActiveRequestService(+idUser);
      const list = Array.isArray(response) ? response : [];
      const pending = list.filter((item: any) => item.responseWithdrawalRequest === null);
      setValidateRequestPending(pending.length > 0);
    } catch (error) {
      console.error("getActiveRequest error:", error);
      setValidateRequestPending(false);
    }
  };

  const registerWithdrawalRequest = async (data: { idUser: number; idCredit: number }): Promise<void> => {
    if (!idUser) { window.location.href = "/"; return; }
    try {
      const response = await withdrawalRegisterRequestService(data as any);
      if (response?.statusCode < 299) {
        toast.current?.show({
          severity: "success",
          summary: "¡Listo!",
          detail: "Solicitud enviada correctamente",
          life: 3000,
        });
        await getActiveRequest();
        await findDataUser();
      }
    } catch (error) {
      console.error("registerWithdrawalRequest error:", error);
    }
  };

  useEffect(() => {
    if (activeSession === "false") { window.location.href = "/"; return; }
    setIsLoading(true);
    Promise.all([findDataUser(), getActiveRequest()]).finally(() => setIsLoading(false));
  }, []);

  const formattedBalance = balanceProfileUser !== null
    ? new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(balanceProfileUser)
    : null;

  const currency = (value: any) => {
    if (value === null || value === undefined) return "—";
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "—";
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num);
  };

  return (
    <>
      <style>{styles}</style>
      <div className="hr-root">
        <Toast ref={toast} />
        <ConfirmDialog />

        {/* ── Top bar ── */}
        <header className="hr-topbar">
          <div className="hr-topbar-brand">
            BI<span>Capital</span>
          </div>

          <div className="hr-topbar-right">

            <button className="hr-icon-btn" title="Notificaciones">
              <i className="pi pi-bell" style={{ fontSize: "0.95rem" }} />
              {validateRequestPending && <span className="hr-notif-dot" />}
            </button>

            {/* 👤 Avatar con menú desplegable */}
            <div
              className="hr-avatar-wrap"
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className="hr-avatar"
                title={rawName || "Usuario"}
                onClick={() => setShowAvatarMenu((v) => !v)}
              >
                {initials}
              </div>

              {showAvatarMenu && (
                <div className="hr-avatar-menu">
                  <div
                    className="hr-avatar-menu-item"
                    onClick={() => { setShowAvatarMenu(false); navigate("/profile"); }}
                  >
                    <i className="pi pi-user" />
                    Editar perfil
                  </div>
                  <div className="hr-avatar-menu-divider" />
                  <div
                    className="hr-avatar-menu-item"
                    onClick={() => { setShowAvatarMenu(false); navigate("/"); }}
                  >
                    <i className="pi pi-sign-out" />
                    Cerrar sesión
                  </div>
                </div>
              )}
            </div>

          </div>
        </header>

        <SidebarComponent />

        {/* ── Content ── */}
        <div className="hr-content">
          <main className="hr-main">

            {/* ── Page header ── */}
            <div className="hr-page-header">
              <div>
                <h1>
                  Bienvenido{rawName ? ", " : ""}<span> {rawName} </span> 👋
                </h1>
                <p className="hr-date">{today}</p>
              </div>

              <div className="hr-page-header-right">
                <div className="hr-loading-pill">
                  <span className="hr-dot" />
                  {isLoading ? "Cargando datos…" : "Cuenta activa · Actualizado ahora"}
                </div>
                <Button
                  label="Solicitar crédito"
                  icon="pi pi-plus"
                  className="hr-btn-request-credit"
                  onClick={() => navigate("/credits/request")}
                />
              </div>
            </div>

            {/* ── Dashboard grid ── */}
            <div className="hr-grid">

              {/* Balance hero */}
              <div className="hr-balance-card">
                <div>
                  <div className="hr-balance-label">Saldo disponible</div>
                  <div className="hr-balance-amount">
                    {formattedBalance === null ? (
                      <span className="hr-skeleton" />
                    ) : (
                      <>
                        <span className="hr-bal-sym">$</span>
                        {formattedBalance}
                        <span className="hr-bal-cur">USD</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="hr-balance-meta">
                  <span className="dot" />
                  Cuenta activa · Actualizado al iniciar sesión
                </div>
              </div>

              {/* Withdrawal / pending */}
              <div className="hr-withdraw-card">
                {validateRequestPending && (
                  <div className="hr-pending-badge">
                    <i className="pi pi-check-circle" style={{ fontSize: "1.1rem" }} />
                    Tiene una solicitud de retiro pendiente de respuesta
                  </div>
                )}

                {!validateRequestPending && creditsPendingWithdrawal.length === 0 && (
                  <div className="hr-withdraw-card-empty">
                    <div className="hr-withdraw-icon-wrap">
                      <i className="pi pi-send" />
                    </div>
                    <div className="hr-withdraw-body">
                      <h3>Solicitud de retiro</h3>
                      <p className="hr-sub">Genera tu solicitud de retiro</p>
                      <p>
                        Si tu crédito fue <strong className="hl">aprobado</strong> y{" "}
                        <strong className="hl2">desembolsado</strong>, puedes iniciar una
                        solicitud de retiro.
                      </p>
                    </div>
                  </div>
                )}

                {!validateRequestPending && creditsPendingWithdrawal.length > 0 && (
                  <>
                    <div className="hr-withdraw-title-row">
                      <h3>Créditos desembolsados, listos para solicitar retiro</h3>
                    </div>
                    <div className="hr-withdraw-list">
                      {creditsPendingWithdrawal.map((credit: any) => (
                        <div className="hr-withdraw-item" key={credit.idCredito}>
                          <div className="hr-withdraw-item-info">
                            <span className="hr-withdraw-item-number">{credit.creditNumber}</span>
                            <span className="hr-withdraw-item-amount">
                              Monto desembolsado: <b>{currency(credit.disbursedAmount)}</b>
                            </span>
                          </div>
                          <Button
                            label="Solicitar retiro"
                            icon="pi pi-arrow-right"
                            iconPos="right"
                            className="hr-btn-withdraw"
                            onClick={() => requestSaves(credit.idCredito)}
                            disabled={isLoading}
                          />
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* ── Créditos ── */}
            <div className="hr-charts">
              <div className="hr-charts-header">
                <h4>Mis créditos</h4>
                <span className="hr-charts-pill">Por tipo</span>
              </div>
              <CreditsAccordion creditosPorTipo={creditosPorTipo} />
            </div>

            {/* ── Charts ── */}
            <div className="hr-charts">
              <div className="hr-charts-header">
                <h4>Día a Día</h4>
                <span className="hr-charts-pill">Histórico</span>
              </div>
              <StaticsData />
            </div>

          </main>
        </div>
      </div>
    </>
  );
}

export default Home;